export class Pageable {
  page = 1;
  size = 10;
  totalElements = 20;
}
